import React from 'react';
import { Form, Input, Button, message } from 'antd';
import { Link } from 'react-router-dom';
import { getAuth, sendPasswordResetEmail } from 'firebase/auth';
import './auth.css'; // Import the CSS file

const ForgotPasswordScreen = () => {
  const auth = getAuth();

  const onFinish = async (values) => {
    try {
      await sendPasswordResetEmail(auth, values.email);
      message.success('Password reset email sent!');
    } catch (error) {
      switch (error.code) {
        case 'auth/user-not-found':
          message.error('No user found with this email.');
          break;
        default:
          message.error('Failed to send password reset email. Please try again.');
      }
      console.error('Error:', error);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-background"></div>
      <div className="auth-form-container">
        <h2>Reset Password</h2>
        <Form name="forgot-password" onFinish={onFinish} layout="vertical">
          <Form.Item name="email" rules={[{ required: true, message: 'Please enter your email!' }]}>
            <Input size="large" placeholder="Enter your email" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" className="auth-form-button" size="large">
              Send Reset Email
            </Button>
          </Form.Item>
          <div>
            Remembered your password? <Link to="/login">Login</Link>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default ForgotPasswordScreen;
